<template>
  <div class="base-introduction-page">
    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd"
        >新增</el-button
      >
    </div>

    <el-table
      :data="baseList"
      border
      class="custom-table"
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="sortOrder" label="排序" width="55" />
      <el-table-column label="基地名称" prop="baseName" min-width="120" />
      <el-table-column label="基地位置" min-width="160">
        <template slot-scope="scope">
          {{ formatLocation(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        label="大棚个数"
        prop="greenhouseCount"
        width="100"
        align="center"
      />
      <el-table-column label="联系人" prop="contactPerson" width="120" />
      <el-table-column label="联系电话" prop="contactTel" width="140" />
      <el-table-column label="基地图片" width="120" align="center">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.baseImage"
            :src="scope.row.baseImage"
            fit="cover"
            class="table-thumb"
            :preview-src-list="[scope.row.baseImage]"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" prop="updateTime" min-width="160" />
      <el-table-column label="状态" prop="statusLabel" width="90" align="center">
        <template slot-scope="scope">
          <span
            :class="[
              'status-tag',
              scope.row.statusCode === 1
                ? 'status-published'
                : 'status-draft',
            ]"
          >
            {{ scope.row.statusLabel }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="scope.row.id !== '1'"
            class="danger-text"
            @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button
          >
          <el-button type="text" @click="handleView(scope.row)">查看</el-button>
          <el-button type="text" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog
      :title="isViewMode ? '基地详情' : formDialogTitle"
      :visible.sync="formDialogVisible"
      width="900px"
      @close="resetForm"
    >
      <el-form
        :model="baseForm"
        :rules="baseRules"
        ref="baseFormRef"
        label-width="110px"
        class="base-form"
      >
        <div class="form-grid">
          <el-form-item label="排序" prop="sortOrder">
            <el-input-number
              v-model.number="baseForm.sortOrder"
              :min="1"
              :step="1"
              :precision="0"
              placeholder="请输入序号"
              clearable
              :disabled="isViewMode"
            />
          </el-form-item>
          <el-form-item label="基地名称" prop="baseName">
            <el-input
              v-model="baseForm.baseName"
              placeholder="请输入"
              clearable
              :disabled="isViewMode"
            />
          </el-form-item>
          <el-form-item label="基地位置" prop="county">
            <div class="location-selects">
              <el-select
                v-model="baseForm.province"
                placeholder="省份"
                @change="handleProvinceChange"
                :disabled="isViewMode"
              >
                <el-option
                  v-for="item in provinceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-select
                v-model="baseForm.city"
                placeholder="城市"
                @change="handleCityChange"
                :disabled="isViewMode"
              >
                <el-option
                  v-for="item in cityOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-select
                v-model="baseForm.county"
                placeholder="区县"
                @change="handleDistrictChange"
                :disabled="isViewMode"
              >
                <el-option
                  v-for="item in countyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="详细地址" prop="detailAddress">
            <el-input
              v-model="baseForm.detailAddress"
              placeholder="请输入"
              clearable
              :disabled="isViewMode"
            />
          </el-form-item>
          <el-form-item label="基地经度" prop="longitude">
            <el-input
              v-model="baseForm.longitude"
              placeholder="请输入含6位小数的经度"
              clearable
              :disabled="isViewMode"
            />
          </el-form-item>
          <el-form-item label="基地纬度" prop="latitude">
            <el-input
              v-model="baseForm.latitude"
              placeholder="请输入含6位小数的纬度"
              clearable
              :disabled="isViewMode"
            />
          </el-form-item>
          <el-form-item label="大棚个数" prop="greenhouseCount">
            <el-input
              v-model="baseForm.greenhouseCount"
              placeholder="请输入数值"
              clearable
              :disabled="isViewMode"
            >
              <template slot="append">个</template>
            </el-input>
          </el-form-item>
          <el-form-item label="总占地面积" prop="totalArea">
            <el-input
              v-model="baseForm.totalArea"
              placeholder="请输入数值"
              clearable
              :disabled="isViewMode"
            >
              <template slot="append">亩</template>
            </el-input>
          </el-form-item>
          <el-form-item label="种植规模" prop="plantingScale">
            <el-input
              v-model="baseForm.plantingScale"
              placeholder="请输入数值"
              clearable
              :disabled="isViewMode"
            >
              <template slot="append">亩</template>
            </el-input>
          </el-form-item>
          <el-form-item label="预计产量" prop="estimatedYield">
            <el-input
              v-model="baseForm.estimatedYield"
              placeholder="请输入数值"
              clearable
              :disabled="isViewMode"
            >
              <template slot="append">万斤</template>
            </el-input>
          </el-form-item>
          <el-form-item label="品种类型" prop="varietyType">
            <el-input
              v-model="baseForm.varietyType"
              placeholder="请输入"
              clearable
              :disabled="isViewMode"
            />
          </el-form-item>
          <el-form-item label="所处时期" prop="currentStage">
            <el-select v-model="baseForm.currentStage" placeholder="请选择" :disabled="isViewMode">
              <el-option
                v-for="item in currentStageOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="	亩均收益" prop="yieldPerMu">
            <el-input
              v-model="baseForm.yieldPerMu"
              placeholder="请输入数值"
              clearable
              :disabled="isViewMode"
            >
              <template slot="append">斤/亩</template>
            </el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contactPerson">
            <el-input
              v-model="baseForm.contactPerson"
              placeholder="请输入"
              clearable
              :disabled="isViewMode"
            />
          </el-form-item>
          <el-form-item label="联系方式" prop="contactTel">
            <el-input
              v-model="baseForm.contactTel"
              placeholder="请输入手机号"
              clearable
              :disabled="isViewMode"
            />
          </el-form-item>
          <el-form-item label="基地图片">
            <div class="image-upload-wrapper">
              <template v-if="isViewMode">
                <el-image
                  v-if="baseForm.baseImage"
                  :src="baseForm.baseImage"
                  fit="cover"
                  class="form-view-image"
                  :preview-src-list="[baseForm.baseImage]"
                />
                <span v-else class="empty-text">暂无图片</span>
              </template>
              <template v-else>
                <ImageUpload
                  v-model="baseImageUrlArray"
                  :maxCount="1"
                  accept=".png,.jpg,.jpeg"
                  @uploading="handleBaseImageUploading"
                />
                <div class="upload-tip">
                  注: 仅支持 png、jpg，最多上传 1 张
                </div>
              </template>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formDialogVisible = false">{{ isViewMode ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!isViewMode" @click="handleSave('draft')">暂存</el-button>
        <el-button
          v-if="!isViewMode && !isPublishing"
          type="primary"
          @click="handleSave('publish')"
          >发布</el-button
        >
        <el-button v-if="!isViewMode && isEditing" type="success" @click="handleSave('update')"
          >修改</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  fetchPlantingBaseList,
  addPlantingBase,
  editPlantingBase,
  getPlantingBaseDetail,
  deletePlantingBase,
} from "@/api/plantingBase";
import ImageUpload from "@/components/ImageUpload.vue";
import areaTree from "@/utils/areaCode";

const provinceOptions = buildProvinceOptions(areaTree);

function buildProvinceOptions(tree = []) {
  return tree.map((province) => ({
    value: province.text,
    label: province.text,
    code: province.value,
    cities: (province.children || []).map((city) => ({
      value: city.text,
      label: city.text,
      code: city.value,
      countys: (city.children || []).map((county) => ({
        value: county.text,
        label: county.text,
        code: county.value,
      })),
    })),
  }));
}

export default {
  name: "BaseIntroduction",
  components: {
    ImageUpload,
  },
  data() {
    return {
      baseList: [],
      tableLoading: false,
      page: 1,
      pageSize: 10,
      totalCount: 0,
      isViewMode: false,
      provinceOptions,
      currentStageOptions: [
        { label: "育苗期", value: "育苗期" },
        { label: "缓苗期", value: "缓苗期" },
        { label: "生长期", value: "生长期" },
        { label: "现蕾期", value: "现蕾期" },
        { label: "花期", value: "花期" },
        { label: "膨果期", value: "膨果期" },
        { label: "转色期", value: "转色期" },
        { label: "采收期", value: "采收期" },
      ],
      activeIndex: -1,
      formDialogVisible: false,
      baseForm: null,
      baseImageUrlArray: [],
      isBaseImageUploading: false,
      formSubmitting: false,
      baseRules: {
        sortOrder: [{ required: true, message: "请输入排序", trigger: "blur" }],
        baseName: [
          { required: true, message: "请输入基地名称", trigger: "blur" },
        ],
        detailAddress: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        longitude: [
          { required: true, message: "请输入基地经度", trigger: "blur" },
          {
            validator: (rule, value, callback) =>
              this.validateDecimal(value, callback),
            trigger: "blur",
          },
        ],
        latitude: [
          { required: true, message: "请输入基地纬度", trigger: "blur" },
          {
            validator: (rule, value, callback) =>
              this.validateDecimal(value, callback),
            trigger: "blur",
          },
        ],
        greenhouseCount: [
          {
            validator: (rule, value, callback) =>
              this.validateNumber(value, callback),
            trigger: "blur",
          },
        ],
        totalArea: [
          {
            validator: (rule, value, callback) =>
              this.validateNumber(value, callback),
            trigger: "blur",
          },
        ],
        plantingScale: [
          {
            validator: (rule, value, callback) =>
              this.validateNumber(value, callback),
            trigger: "blur",
          },
        ],
        estimatedYield: [
          {
            validator: (rule, value, callback) =>
              this.validateNumber(value, callback),
            trigger: "blur",
          },
        ],
        yieldPerMu: [
          {
            validator: (rule, value, callback) =>
              this.validateNumber(value, callback),
            trigger: "blur",
          },
        ],
        contactPerson: [],
        contactTel: [
          {
            validator: (rule, value, callback) =>
              this.validatePhone(value, callback),
            trigger: "blur",
          },
        ],
        county: [
          {
            required: true,
            message: "请选择省/市/区",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    isEditing() {
      return Boolean(
        this.baseForm && (this.baseForm.id || this.baseForm.id === 0)
      );
    },
    isPublishing() {
      return this.baseForm.statusCode === 1;
    },
    formDialogTitle() {
      return this.isEditing ? "编辑基地" : "新增基地";
    },
    cityOptions() {
      if (!this.baseForm) return [];
      const province = this.provinceOptions.find(
        (item) => item.value === this.baseForm.province
      );
      return province ? province.cities : [];
    },
    countyOptions() {
      if (!this.baseForm) return [];
      const city = this.cityOptions.find(
        (item) => item.value === this.baseForm.city
      );
      return city ? city.countys : [];
    },
  },
  watch: {
    baseImageUrlArray(newVal) {
      if (!this.baseForm) return;
      const list = Array.isArray(newVal) ? newVal.filter(Boolean) : [];
      const [first] = list;
      this.baseForm.baseImage = first || "";
      this.baseForm.imageUrl = list.length > 1 ? [...list] : first || "";
      this.baseForm.imageUrlList = list;
    },
  },
  created() {
    this.baseForm = this.getEmptyForm();
    this.syncBaseImageSelection();
    this.fetchBaseList();
  },
  methods: {
    async fetchBaseList() {
      this.tableLoading = true;
      try {
        const res = await fetchPlantingBaseList({
          page: this.page,
          pageSize: this.pageSize,
        });
        const { list = [], totalCount = 0 } = res.data || {};
        this.baseList = list.map((item) => this.normalizeBaseData(item));
        this.totalCount = parseInt(totalCount);
      } catch (error) {
        console.error("Failed to fetch planting base list", error);
      } finally {
        this.tableLoading = false;
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchBaseList();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.fetchBaseList();
    },
    normalizeBaseData(item = {}) {
      const baseImage = this.normalizeImageUrl(item.imageUrl);
      const statusCode = this.normalizeStatusCode(item);
      return {
        id: item.id ?? null,
        sortOrder: this.formatNumberValue(item.sortOrder),
        baseName: item.baseName ?? "",
        province: item.province ?? "",
        provinceCode: item.provinceCode ?? "",
        city: item.city ?? "",
        cityCode: item.cityCode ?? "",
        county: item.county ?? "",
        countyCode: item.countyCode ?? "",
        detailAddress: item.detailAddress ?? "",
        longitude: this.formatNumberValue(item.longitude),
        latitude: this.formatNumberValue(item.latitude),
        greenhouseCount: this.formatNumberValue(item.greenhouseCount),
        totalArea: this.formatNumberValue(item.totalArea),
        plantingScale: this.formatNumberValue(item.plantingScale),
        estimatedYield: this.formatNumberValue(item.estimatedYield),
        varietyType: item.varietyType ?? "",
        currentStage: item.currentStage ?? "",
        yieldPerMu: this.formatNumberValue(item.yieldPerMu),
        contactPerson: item.contactPerson ?? "",
        contactTel: item.contactTel ?? "",
        baseImage,
        imageUrl: this.normalizeImageList(item.imageUrl),
        imageUrlList: this.normalizeImageList(item.imageUrl),
        statusCode,
        statusLabel: statusCode === 1 ? "已发布" : "草稿",
        updateTime: this.formatApiDate(item.updateTime),
      };
    },
    formatNumberValue(value) {
      if (value === null || value === undefined || value === "") return "";
      return `${value}`;
    },
    normalizeImageUrl(imageUrl) {
      if (Array.isArray(imageUrl) && imageUrl.length > 0) {
        const first = imageUrl[0];
        if (typeof first === "string") {
          return first;
        }
        if (first && typeof first === "object") {
          return first.url || first.imageUrl || first.path || "";
        }
      }
      if (typeof imageUrl === "string") {
        return imageUrl;
      }
      return "";
    },
    formatApiDate(value) {
      if (!value && value !== 0) {
        return "";
      }
      if (typeof value === "string") {
        return value;
      }
      if (typeof value === "number") {
        return this.formatTimestamp(value);
      }
      if (value && typeof value === "object") {
        if (value.time) {
          return this.formatTimestamp(value.time);
        }
        if (value.date) {
          const date = new Date(value.date);
          return Number.isNaN(date.getTime())
            ? ""
            : this.formatTimestamp(date.getTime());
        }
      }
      return "";
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      if (Number.isNaN(date.getTime())) {
        return "";
      }
      const yyyy = date.getFullYear();
      const mm = `${date.getMonth() + 1}`.padStart(2, "0");
      const dd = `${date.getDate()}`.padStart(2, "0");
      const hh = `${date.getHours()}`.padStart(2, "0");
      const mi = `${date.getMinutes()}`.padStart(2, "0");
      const ss = `${date.getSeconds()}`.padStart(2, "0");
      return `${yyyy}/${mm}/${dd} ${hh}:${mi}:${ss}`;
    },
    getEmptyForm() {
      return {
        id: null,
        sortOrder: "",
        baseName: "",
        province: "",
        provinceCode: "",
        city: "",
        cityCode: "",
        county: "",
        countyCode: "",
        detailAddress: "",
        longitude: "",
        latitude: "",
        greenhouseCount: "",
        totalArea: "",
        plantingScale: "",
        estimatedYield: "",
        varietyType: "",
        currentStage: "",
        yieldPerMu: "",
        contactPerson: "",
        contactTel: "",
        baseImage: "",
        imageUrl: [],
        imageUrlList: [],
        statusCode: 0,
        statusLabel: "草稿",
        updateTime: "",
      };
    },
    normalizeStatusCode(item = {}) {
      if (typeof item.status === "number") {
        return item.status;
      }
      if (typeof item.statusCode === "number") {
        return item.statusCode;
      }
      const statusText = item.status || item.statusLabel;
      if (statusText === "已发布") {
        return 1;
      }
      return 0;
    },
    normalizeImageList(imageUrl) {
      if (Array.isArray(imageUrl)) {
        return imageUrl.filter(Boolean);
      }
      if (typeof imageUrl === "string" && imageUrl.trim()) {
        return [imageUrl.trim()];
      }
      if (imageUrl && typeof imageUrl === "object") {
        const url =
          imageUrl.url || imageUrl.imageUrl || imageUrl.path || imageUrl.src;
        return url ? [url] : [];
      }
      return [];
    },
    formatLocation(row) {
      return [row.province, row.city, row.county].filter(Boolean).join("/");
    },
    handleAdd() {
      this.activeIndex = -1;
      this.isViewMode = false;
      this.baseForm = this.getEmptyForm();
      this.baseImageUrlArray = [];
      this.isBaseImageUploading = false;
      this.formDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.baseFormRef) {
          this.$refs.baseFormRef.clearValidate();
        }
      });
    },
    async handleEdit(index, row) {
      this.activeIndex = index;
      this.isViewMode = false;
      if (!row.id && row.id !== 0) {
        this.$message.error("当前记录缺少ID，无法编辑");
        return;
      }
      try {
        const detail = await this.fetchDetail(row.id);
        this.baseForm = this.mapDetailToForm(detail);
        this.isBaseImageUploading = false;
        this.syncBaseImageSelection();
        this.formDialogVisible = true;
      } catch (error) {
        console.error("Failed to fetch base detail", error);
      }
    },
    async handleView(row) {
      if (!row.id && row.id !== 0) {
        this.$message.error("当前记录缺少ID，无法查看");
        return;
      }
      try {
        const detail = await this.fetchDetail(row.id);
        this.isViewMode = true;
        this.baseForm = this.mapDetailToForm(detail);
        this.isBaseImageUploading = false;
        this.syncBaseImageSelection();
        this.formDialogVisible = true;
      } catch (error) {
        console.error("Failed to fetch base detail", error);
      }
    },
    async fetchDetail(id) {
      const res = await getPlantingBaseDetail(id);
      return res.data || {};
    },
    mapDetailToForm(detail = {}) {
      return {
        ...this.normalizeBaseData(detail),
      };
    },
    syncBaseImageSelection() {
      if (!this.baseForm) {
        this.baseImageUrlArray = [];
        return;
      }
      const urls = Array.isArray(this.baseForm.imageUrlList)
        ? this.baseForm.imageUrlList.filter(Boolean)
        : [];
      if (urls.length) {
        this.baseImageUrlArray = [...urls];
        return;
      }
      if (this.baseForm.baseImage) {
        this.baseImageUrlArray = [this.baseForm.baseImage];
        return;
      }
      this.baseImageUrlArray = [];
    },
    handleDelete(index, row) {
      if (!row.id && row.id !== 0) {
        this.$message.error("当前记录缺少ID，无法删除");
        return;
      }
      this.$confirm("确认删除该基地信息？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await deletePlantingBase(row.id);
          this.$message.success("已删除");
          if (this.baseList.length === 1 && this.page > 1) {
            this.page -= 1;
          }
          this.fetchBaseList();
        })
        .catch(() => {});
    },
    async handleSave(action) {
      if (this.formSubmitting) return;
      if (this.isBaseImageUploading) {
        this.$message.warning("图片正在上传,请稍候...");
        return;
      }
      
      // 暂存时校验基地名称必填
      if (action === 'draft') {
        // 校验基地名称
        if (!this.baseForm.baseName || !this.baseForm.baseName.trim()) {
          this.$message.warning("请输入基地名称");
          return;
        }
        
        const statusCode = this.getStatusByAction(action);
        this.formSubmitting = true;
        try {
          const payload = {
            ...this.baseForm,
            statusCode:
              statusCode === undefined
                ? this.baseForm?.statusCode ?? 0
                : statusCode,
          };
          payload.imageUrl = this.baseImageUrlArray.filter(Boolean);
          delete payload.imageUrlList;
          payload.status = payload.statusCode;
          if (this.isEditing) {
            await editPlantingBase(payload);
          } else {
            await addPlantingBase(payload);
          }
          this.$message.success("已暂存");
          this.formDialogVisible = false;
          this.fetchBaseList();
        } finally {
          this.formSubmitting = false;
        }
        return;
      }
      
      // 发布和修改需要校验
      this.$refs.baseFormRef.validate(async (valid) => {
        if (!valid) return;
        const statusCode = this.getStatusByAction(action);
        this.formSubmitting = true;
        try {
          const payload = {
            ...this.baseForm,
            statusCode:
              statusCode === undefined
                ? this.baseForm?.statusCode ?? 0
                : statusCode,
          };
          payload.imageUrl = this.baseImageUrlArray.filter(Boolean);
          delete payload.imageUrlList;
          payload.status = payload.statusCode;
          if (this.isEditing) {
            await editPlantingBase(payload);
          } else {
            await addPlantingBase(payload);
          }
          const messageMap = {
            publish: "已发布",
            update: "已更新",
          };
          this.$message.success(messageMap[action] || "操作成功");
          this.formDialogVisible = false;
          this.fetchBaseList();
        } finally {
          this.formSubmitting = false;
        }
      });
    },
    getStatusByAction(action) {
      const map = {
        draft: 0,
        publish: 1,
        update: this.baseForm?.statusCode ?? 0,
      };
      return map[action];
    },

    parseNumber(value) {
      if (value === "" || value === null || value === undefined) {
        return undefined;
      }
      const num = Number(value);
      return Number.isNaN(num) ? undefined : num;
    },
    resetForm() {
      this.$nextTick(() => {
        if (this.$refs.baseFormRef) {
          this.$refs.baseFormRef.resetFields();
        }
        this.baseForm = this.getEmptyForm();
        this.baseImageUrlArray = [];
        this.isBaseImageUploading = false;
        this.activeIndex = -1;
      });
    },
    handleProvinceChange(value) {
      const province = this.getProvinceOptionByValue(value);
      this.baseForm.province = province?.label || "";
      this.baseForm.provinceCode = province?.code || "";
      this.baseForm.city = "";
      this.baseForm.cityCode = "";
      this.baseForm.county = "";
      this.baseForm.countyCode = "";
    },
    handleCityChange(value) {
      const city = this.getCityOptionByValue(value);
      this.baseForm.city = city?.label || "";
      this.baseForm.cityCode = city?.code || "";
      this.baseForm.county = "";
      this.baseForm.countyCode = "";
    },
    handleDistrictChange(value) {
      const county = this.getDistrictOptionByValue(value);
      this.baseForm.county = county?.label || "";
      this.baseForm.countyCode = county?.code || "";
    },
    getProvinceOptionByValue(value) {
      return this.provinceOptions.find((item) => item.value === value);
    },
    getCityOptionByValue(value) {
      return this.cityOptions.find((item) => item.value === value);
    },
    getDistrictOptionByValue(value) {
      return this.countyOptions.find((item) => item.value === value);
    },
    handleBaseImageUploading(status) {
      this.isBaseImageUploading = status;
    },
    validateDecimal(value, callback) {
      if (!value) {
        callback();
      } else if (!/^-?\d+(\.\d{1,6})?$/.test(value)) {
        callback(new Error("请输入数值，最多6位小数"));
      } else {
        callback();
      }
    },
    validateNumber(value, callback) {
      if (!value) {
        callback();
      } else if (!/^\d+(\.\d+)?$/.test(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    },
    validatePhone(value, callback) {
      if (!value) {
        callback();
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("请输入11位手机号"));
      } else {
        callback();
      }
    },
  },
};
</script>

<style scoped lang="less">
.base-introduction-page {
  padding: 20px;
  background: #060913;
  color: #e1e6f5;

  .toolbar {
    margin-bottom: 16px;

    .el-button {
      background: #1494ff;
      border-color: #1494ff;
    }
  }
}

.custom-table {
  background: transparent;

  th {
    background: rgba(24, 30, 50, 0.95);
    color: #8fb1ff;
  }

  td {
    background: rgba(6, 9, 19, 0.95);
    color: #e9ecf7;
  }

  .table-thumb {
    width: 60px;
    height: 45px;
    border-radius: 4px;
    border: 1px solid #2f3650;
  }
}

.pagination-container {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
}

.status-published {
  background: rgba(17, 159, 255, 0.15);
  color: #11a0ff;
}

.status-draft {
  background: rgba(255, 101, 91, 0.15);
  color: #ff655b;
}

.danger-text {
  color: #f56c6c;
}

.base-form {
  .form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(280px, 1fr));
    grid-column-gap: 24px;
  }

  .location-selects {
    display: flex;
    gap: 8px;

    .el-select {
      flex: 1;
    }
  }

  .image-upload-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .upload-tip {
    font-size: 12px;
    color: #909399;
  }
}

.detail-image {
  width: 240px;
  height: 160px;
  border-radius: 6px;
  border: 1px solid #2f3650;
}

.form-view-image {
  width: 240px;
  height: 160px;
  border-radius: 6px;
  border: 1px solid #2f3650;
  object-fit: cover;
  cursor: pointer;
}

.empty-text {
  color: #909399;
  font-size: 14px;
}

/deep/.el-descriptions__body{
  background-color: rgba(0, 11, 47, 0.5) !important;
}
/deep/.el-descriptions--mini.is-bordered .el-descriptions-item__cell{
  background-color: rgba(0, 11, 47, 0.5) !important;
}
</style>
